/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { BookingAppointmentBlockerTypePermissions } from './bookingAppointmentBlockerTypePermissions';
import { BookingCapacityQuotaPermissions } from './bookingCapacityQuotaPermissions';
import { BookingWaitlistEntryPermissions } from './bookingWaitlistEntryPermissions';
import { BookingAppointmentCreateConfigurationPermissions } from './bookingAppointmentCreateConfigurationPermissions';
import { BookingAppointmentSyncStatusPermissions } from './bookingAppointmentSyncStatusPermissions';
import { BookingAppointmentResourcePermissions } from './bookingAppointmentResourcePermissions';
import { BookingAvailabilityExclusionPermissions } from './bookingAvailabilityExclusionPermissions';
import { BookingAppointmentPermissions } from './bookingAppointmentPermissions';
import { BookingAppointmentTypePermissions } from './bookingAppointmentTypePermissions';
import { BookingAppointmentManageConfigurationPermissions } from './bookingAppointmentManageConfigurationPermissions';
import { BookingDoctolibSyncJobPermissions } from './bookingDoctolibSyncJobPermissions';
import { BookingAppointmentBlockerSeriesPermissions } from './bookingAppointmentBlockerSeriesPermissions';
import { BookingAvailabilitySchedulePermissions } from './bookingAvailabilitySchedulePermissions';
import { BookingDoctolibTwoFactorCodePermissions } from './bookingDoctolibTwoFactorCodePermissions';
import { BookingAvailabilityWindowPermissions } from './bookingAvailabilityWindowPermissions';
import { BookingAppointmentBlockerPermissions } from './bookingAppointmentBlockerPermissions';
import { BookingCapacityQuotaClusterPermissions } from './bookingCapacityQuotaClusterPermissions';
import { BookingDoctolibInboundAppointmentPermissions } from './bookingDoctolibInboundAppointmentPermissions';


import {ValidatorFn, Validators} from "@angular/forms";

export interface BookingPermissions { 
    appointment: BookingAppointmentPermissions;
    appointmentBlocker: BookingAppointmentBlockerPermissions;
    appointmentBlockerSeries: BookingAppointmentBlockerSeriesPermissions;
    appointmentBlockerType: BookingAppointmentBlockerTypePermissions;
    appointmentCreateConfiguration: BookingAppointmentCreateConfigurationPermissions;
    appointmentManageConfiguration: BookingAppointmentManageConfigurationPermissions;
    appointmentResource: BookingAppointmentResourcePermissions;
    appointmentSyncStatus: BookingAppointmentSyncStatusPermissions;
    appointmentType: BookingAppointmentTypePermissions;
    availabilityExclusion: BookingAvailabilityExclusionPermissions;
    availabilitySchedule: BookingAvailabilitySchedulePermissions;
    availabilityWindow: BookingAvailabilityWindowPermissions;
    capacityQuota: BookingCapacityQuotaPermissions;
    capacityQuotaCluster: BookingCapacityQuotaClusterPermissions;
    doctolibInboundAppointment: BookingDoctolibInboundAppointmentPermissions;
    doctolibSyncJob: BookingDoctolibSyncJobPermissions;
    doctolibTwoFactorCode: BookingDoctolibTwoFactorCodePermissions;
    waitlistEntry: BookingWaitlistEntryPermissions;
}
export const BookingPermissions_appointment_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_appointmentBlocker_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_appointmentBlockerSeries_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_appointmentBlockerType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_appointmentCreateConfiguration_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_appointmentManageConfiguration_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_appointmentResource_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_appointmentSyncStatus_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_appointmentType_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_availabilityExclusion_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_availabilitySchedule_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_availabilityWindow_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_capacityQuota_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_capacityQuotaCluster_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_doctolibInboundAppointment_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_doctolibSyncJob_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_doctolibTwoFactorCode_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const BookingPermissions_waitlistEntry_Validators: ValidatorFn[] =
    [  Validators.required, ];


